import enUs from 'antd/lib/locale/en_US';
import { useCallback, useState } from 'react';

const localeMap = {
  enUs,
};

type SupportedLocales = keyof typeof localeMap;

export const useLocale = () => {
  const [locale, setLocale] = useState<SupportedLocales>(
    (localStorage.getItem('locale') as SupportedLocales) || 'enUs'
  );

  const changeLocale = useCallback((locale: SupportedLocales) => {
    localStorage.setItem('locale', locale);
    setLocale(locale);
  }, []);

  return { locale: localeMap[locale], changeLocale };
};
